// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".link-view .loading-component[data-v-3c7407f0]{border-radius:6px}", ""]);
// Exports
module.exports = exports;
